import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Page.Query = {
  selection: {
    if: [
      [
        {
          '=': [
            {
              '@$': 'orgEntityId',
            },
            'ent:!org:!dept',
          ],
        },
        {
          '@': 'deptLens',
        },
      ],
      [
        {
          '=': [
            {
              '@$': 'orgEntityId',
            },
            'ent:!org:!subdept',
          ],
        },
        {
          '@': 'subdeptLens',
        },
      ],
      {
        '@': 'InstitutionLens',
      },
    ],
  },
  subqueries: {
    deptLens: {
      filter: {
        or: [
          {
            '=': [
              {
                '@$': 'orgRecordId',
              },
              null,
            ],
          },
          {
            '=': [
              {
                '@$': 'orgRecordId',
              },
              {
                '@.': '!id',
              },
            ],
          },
        ],
      },
      target: 'ent:!org:!dept',
      quantity: 1,
      selection: {
        '{}': {
          title: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'orgEntityId',
                    },
                    'ent:!org:!dept',
                  ],
                },
                {
                  '@.': '!name',
                },
              ],
              'Institution',
            ],
          },
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  {
                    '@.': '!id',
                  },
                ],
              },
            ],
          },
          breadcrumbs: {
            '++': [
              {
                '[]': [
                  {
                    '{}': {
                      goto: {
                        '{}': {
                          variables: {
                            '{}': {},
                          },
                          navigationId: 'trends',
                        },
                      },
                      name: 'Institution',
                    },
                  },
                ],
              },
              {
                '@': 'ancestorsBreadcrumbs',
              },
            ],
          },
        },
      },
      subqueries: {
        ancestorsBreadcrumbs: {
          target: 'ancestors',
          selection: {
            '{}': {
              goto: {
                '{}': {
                  variables: {
                    '{}': {
                      title: 'Departments',
                      orgEntityId: {
                        '@_': 'id',
                      },
                      orgRecordId: {
                        '@.': '!id',
                      },
                    },
                  },
                  navigationId: 'trends',
                },
              },
              name: {
                '@.': '!name',
              },
            },
          },
        },
      },
    },
    subdeptLens: {
      filter: {
        or: [
          {
            '=': [
              {
                '@$': 'orgRecordId',
              },
              null,
            ],
          },
          {
            '=': [
              {
                '@$': 'orgRecordId',
              },
              {
                '@.': '!id',
              },
            ],
          },
        ],
      },
      target: 'ent:!org:!subdept',
      quantity: 1,
      selection: {
        '{}': {
          title: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'orgEntityId',
                    },
                    'ent:!org:!subdept',
                  ],
                },
                {
                  '@.': '!name',
                },
              ],
              'Institution',
            ],
          },
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  {
                    '@.': '!id',
                  },
                ],
              },
            ],
          },
          breadcrumbs: {
            '++': [
              {
                '[]': [
                  {
                    '{}': {
                      goto: {
                        '{}': {
                          variables: {
                            '{}': {},
                          },
                          navigationId: 'trends',
                        },
                      },
                      name: 'Institution',
                    },
                  },
                ],
              },
              {
                '@': 'ancestorsBreadcrumbs',
              },
            ],
          },
        },
      },
      subqueries: {
        ancestorsBreadcrumbs: {
          target: 'ancestors',
          selection: {
            '{}': {
              goto: {
                '{}': {
                  variables: {
                    '{}': {
                      title: 'Subdepartments',
                      orgEntityId: {
                        '@_': 'id',
                      },
                      orgRecordId: {
                        '@.': '!id',
                      },
                    },
                  },
                  navigationId: 'trends',
                },
              },
              name: {
                '@.': '!name',
              },
            },
          },
        },
      },
    },
    InstitutionLens: {
      target: 'ent:!org:!dept',
      quantity: 1,
      selection: {
        '{}': {
          title: 'Institution',
        },
      },
    },
  },
}
